import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import type { ParentIssueType } from '@risksmart-app/domain/src/types/consts';
import type { Issue_Bool_Exp } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetIssuesDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';
import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetIssueRegister as useGetIssueRegisterTRPC } from './useGetIssueRegisterTRPC';
export const useGetIssueRegister = (
  issueType: ParentIssueType,
  skip?: boolean
) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const where = useEntityWhereFilter<Issue_Bool_Exp>(Parent_Type_Enum.Issue, {
    Type: {
      _eq: issueType,
    },
  });

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetIssuesDocument, {
    variables: {
      where,
    },
    fetchPolicy: 'no-cache',
    skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetIssueRegisterTRPC(issueType, skip);

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
  };
};
